import React from "react"

import OpenIdSSOLoader from "components/common/openIdSSOLoader"
import { useOpenIdSSO } from "hooks/openIdSSO/useOpenIdSSO"

interface IOpenIdSSOLoadersProps {
  userType: "teacher" | "student"
  isSignup?: boolean
}

// Wires both passive, OpenID-style SSO providers (TeachHub and ClassLink) for
// a screen in one place, so screens don't each repeat the same two-hook,
// two-loader wiring shape. Clever SSO stays separate (own active-button
// flow) and is not part of this bundle.
const OpenIdSSOLoaders: React.FC<IOpenIdSSOLoadersProps> = ({
  userType,
  isSignup,
}) => {
  const {
    isOpenIdSSOLoading: isTeachHubSSOLoading,
    handleOpenIdReset: handleTeachHubReset,
    handleOpenIdAuthSuccess: handleTeachHubAuthSuccess,
  } = useOpenIdSSO({ provider: "teachhub", userType, isSignup })
  const {
    isOpenIdSSOLoading: isClassLinkSSOLoading,
    handleOpenIdReset: handleClassLinkReset,
    handleOpenIdAuthSuccess: handleClassLinkAuthSuccess,
  } = useOpenIdSSO({ provider: "classlink", userType, isSignup })

  return (
    <>
      <OpenIdSSOLoader
        provider="teachhub"
        isLoading={isTeachHubSSOLoading}
        userType={userType}
        onReset={handleTeachHubReset}
        onAuthSuccess={handleTeachHubAuthSuccess}
      />
      <OpenIdSSOLoader
        provider="classlink"
        isLoading={isClassLinkSSOLoading}
        userType={userType}
        onReset={handleClassLinkReset}
        onAuthSuccess={handleClassLinkAuthSuccess}
      />
    </>
  )
}

export default OpenIdSSOLoaders
